import themeEditor from './themeEditor';

export default () => {
  if (!$('.image-with-text').length) {
    return false;
  }

  themeEditor();

  return true;
};
